import { createRootRoute, createRoute, createRouter } from "@tanstack/react-router";
import { Root } from "./routes/__root.tsx";
import { Index } from "./routes/index.tsx";
import { Login } from "./routes/login.tsx";
import { Workflow } from "./routes/workflow.tsx";
import { ReceiptList } from "./routes/receipt/index.tsx";
import { ReceiptPicking } from "./routes/receipt/$ref.tsx";
import { DispatchList } from "./routes/dispatch/index.tsx";
import { DispatchPicking } from "./routes/dispatch/$ref.tsx";
import { TransferStart } from "./routes/transfer/index.tsx";
import { TransferScan } from "./routes/transfer/$ref.tsx";
import { BagLookup } from "./routes/lookup.tsx";
import { AdminAudit } from "./routes/admin/index.tsx";

const rootRoute = createRootRoute({ component: Root });

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: Index,
});

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  component: Login,
});

const workflowRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/workflow",
  component: Workflow,
});

const receiptIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/receipt",
  component: ReceiptList,
});

const receiptRefRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/receipt/$ref",
  component: ReceiptPicking,
});

const dispatchIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/dispatch",
  component: DispatchList,
});

const dispatchRefRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/dispatch/$ref",
  component: DispatchPicking,
});

const transferIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/transfer",
  component: TransferStart,
});

const transferRefRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/transfer/$ref",
  component: TransferScan,
});

const lookupRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/lookup",
  component: BagLookup,
});

const adminAuditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/admin",
  component: AdminAudit,
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  workflowRoute,
  receiptIndexRoute,
  receiptRefRoute,
  dispatchIndexRoute,
  dispatchRefRoute,
  transferIndexRoute,
  transferRefRoute,
  lookupRoute,
  adminAuditRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
